import React,{ useState,useEffect } from 'react'
import Newonkaay from './newonkaay'
import Tophashtags from './tophashtags'
import TopSearch from './topSearch'
import Kaaycloset from './kaaycloset'
import Youmayknow from './youmayknow'
import Artandlifestyle from './artandlifestyle'
import Fys from './fys'
import WholeSale from './wholeSale'
import TopSellerAccounts from './topSellerAccounts'
import ApiUrl from '../../../../configTools/apiUrl'

const Index = () => {
    const [b2c,setB2c] = useState([]);
    const [art,setArt] = useState([]);
    const [wholesale,setWholesale] = useState([]);
    const [userListing,setuserListing] = useState([]);
    useEffect(()=>{
      fetch(ApiUrl.API_URL_ListingState+"/0")
      .then(res=>res.json())
      .then(data =>{
          if(data.success){
            setuserListing(data.responce.data1);
            setB2c(data.responce.data2);
            setArt(data.responce.data3);
            setWholesale(data.responce.data4);
          }
      });
    },[])
  return (
    <div className='public_home_explore_container'>
        <Tophashtags/>
        <Newonkaay Products={b2c}/>
        <Kaaycloset Products={userListing}/>
        <Youmayknow/>
        <Artandlifestyle Products={art}/>
        <Fys/>
        <WholeSale Products={wholesale}/>
        <TopSellerAccounts/>
    </div>
  )
}

export default Index
